// The products and section headers a list's grid (#items-load) has loaded, in order. The technical
// markers — the items-end anchor, the beacons — carry neither prefix and stay out of it. One
// reading for the filing flow (last_item_id) and for the next page's cursor (after): should the
// markup change, both move together.
export const PRODUCT_PREFIX = 'product_'
export const SECTION_PREFIX = 'list_section_'

// The class SortableJS puts (chosenClass, set by sortable_controller) on the item being dragged in
// organize mode — and on the copy following the pointer, a DOM clone that keeps its id
// (forceFallback), appended at the end of the grid. Neither says where the item stands in the list:
// the copy is a picture, and the dragged item's place is only saved on release. While the drag
// lasts, neither is a loaded item (#462).
export const DRAGGED = 'sortable-chosen'
const NOT_DRAGGED = `:not(.${DRAGGED})`

export function lastLoadedItem(grid, { productsOnly = false } = {}) {
  const selector = productsOnly
    ? `:scope > [id^="${PRODUCT_PREFIX}"]${NOT_DRAGGED}`
    : `:scope > [id^="${PRODUCT_PREFIX}"]${NOT_DRAGGED}, :scope > [id^="${SECTION_PREFIX}"]${NOT_DRAGGED}`
  const items = grid?.querySelectorAll(selector) ?? []
  return items[items.length - 1]
}
